import React from 'react';
import { string, shape } from 'prop-types';
import { mergeClasses } from '../../classify';
import defaultClasses from './autocomplete.css';
import { useIntl } from 'react-intl';
import Image from '../Image';
import { UNCONSTRAINED_SIZE_KEY } from '@magento/peregrine/lib/talons/Image/useImage';
import Price from '@magento/venia-ui/lib/components/Price';
import { useAppContext } from '@magento/peregrine/lib/context/app';
import { resourceUrl } from "../../drivers";
import BBLink from "../BBLink";
import { boldCurrentSearchBarValueStr } from "./autocomplete";
var IMAGE_WIDTH = 360;
var IMAGE_HEIGHT = 295;
var IMAGE_WIDTHS = new Map().set(640, IMAGE_WIDTH).set(UNCONSTRAINED_SIZE_KEY, 360);
var AutocompleteItem = props => {
  var {
    item,
    productClick
  } = props;
  var [{
    searchBarValue
  }, {
    setOpenSearchBar
  }] = useAppContext();
  var classes = mergeClasses(defaultClasses, props.classes);
  var {
    formatMessage
  } = useIntl();
  var {
    id,
    name,
    sku,
    price,
    salePrice,
    image,
    url_key,
    url_suffix,
    currency,
    yotpo_rating,
    yotpo_reviews_count
  } = item;
  var link = resourceUrl("/".concat(url_key).concat(url_suffix));
  var imageUrl = image && typeof image !== 'undefined' ? image.replace('needtochange/', '') : '';
  var _label = formatMessage({
    id: 'product.item.review',
    defaultMessage: "{totalReview} Review%2".replace('%2', yotpo_reviews_count === 1 ? "" : "s")
  }, {
    totalReview: yotpo_reviews_count
  });
  var productRating = "".concat(yotpo_rating * 20, "%");
  var _savePrice = parseInt((price - salePrice) * 100 / price);
  var text = boldCurrentSearchBarValueStr(name, searchBarValue);
  return /*#__PURE__*/React.createElement("div", {
    key: id,
    className: classes.item
  }, /*#__PURE__*/React.createElement(BBLink, {
    to: link,
    className: classes.content,
    onClick: () => {
      productClick(sku);
      setOpenSearchBar(false);
    }
  }, /*#__PURE__*/React.createElement(Image, {
    alt: name,
    classes: {
      image: classes.image,
      root: classes.imageContainer
    },
    resource: imageUrl,
    height: IMAGE_HEIGHT,
    widths: IMAGE_WIDTHS
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.itemContent
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.name,
    dangerouslySetInnerHTML: {
      __html: text
    }
  }), salePrice !== price && !Number.isNaN(_savePrice) ? /*#__PURE__*/React.createElement("div", {
    className: classes.priceRabais
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.oldPrice
  }, /*#__PURE__*/React.createElement(Price, {
    value: Number(price),
    currencyCode: currency
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.newPrice
  }, /*#__PURE__*/React.createElement(Price, {
    value: Number(salePrice),
    currencyCode: currency
  }), isNaN(_savePrice) || _savePrice < 25 ? null : /*#__PURE__*/React.createElement("span", {
    className: classes.percentOff
  }, "-", _savePrice, "%"))) : !Number.isNaN(_savePrice) ? /*#__PURE__*/React.createElement("div", {
    className: classes.priceRegular
  }, /*#__PURE__*/React.createElement(Price, {
    value: Number(price),
    currencyCode: currency
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: classes.rating
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.defaultRating
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.scoreRating,
    style: {
      width: productRating
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: classes.reviews
  }, _label)))));
};
export default AutocompleteItem;
AutocompleteItem.propTypes = {
  classes: shape({
    innerRoot: string,
    close: string,
    labelTitle: string,
    leftAutocomplete: string,
    rightAutocomplete: string,
    itemContent: string,
    ratingSection: string,
    suggestItem: string,
    suggestLink: string,
    itemsSuggestions: string
  })
};